import { Component, Input, OnInit, OnDestroy } from '@angular/core';
import { Router, NavigationEnd, ActivatedRoute } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { Subscription } from 'rxjs';
import { DetailSidebarItems } from '../../enums/detail-sidebar-items';
import { UtilitySharedService } from '../../shared/_services/utility-shared.service';
import { PermissionsService } from 'shared-lib';

@Component({
  selector: 'app-detail-sidebar',
  templateUrl: './detail-sidebar.component.html',
  styleUrls: ['./detail-sidebar.component.scss'],
  standalone: false,
})
export class DetailSidebarComponent implements OnInit, OnDestroy {
  @Input() title: string = '';
  @Input() items: {
    type: DetailSidebarItems;
    label: string;
    iconKey: string;
    route?: string;
    permission?: string;
  }[] = [];
  collapsed: boolean = false;
  selectedButtonIndex: number | null = null;
  selectedButtonName: string = '';
  selectedRoute: string | undefined = '';
  deviceDropdownOpened: boolean = false;
  selectedItemType: DetailSidebarItems = DetailSidebarItems.TS;
  devicesSidebarItem: DetailSidebarItems = DetailSidebarItems.DEVICES;
  private routeSubscription: Subscription;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private toastr: ToastrService,
    private utilitySharedService: UtilitySharedService,
    public permissionsService: PermissionsService
  ) {
    this.routeSubscription = this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.updateSelectedButton();
      }
    });
  }

  ngOnInit(): void {
    const utilityId = this.utilitySharedService.getUtilityId();

    if (!utilityId) {
      this.items = this.items.filter(
        (item) =>
          !item.route?.includes('data-model-customization-bps') &&
          !item.route?.includes('entity-model-customization')
      );
    }

    if(!this.permissionsService.hasDashboardConfigInjectionSubstation){
      this.items = this.items.filter(
        item => item.type !== DetailSidebarItems.IS
      );
    }

    this.updateSelectedButton();
  }

  ngOnDestroy(): void {
    this.routeSubscription.unsubscribe();
  }

  private updateSelectedButton(): void {
    const currentRoute = this.router.url;
    const matchingIndex = this.items.findIndex(
      (item) => item.route && currentRoute.endsWith(item.route)
    );
    if (matchingIndex !== -1) {
      this.selectedButtonIndex = matchingIndex;
      this.selectedButtonName = this.items[matchingIndex].label;
    }
  }

  toggleSidebar() {
    this.collapsed = !this.collapsed;
  }

  selectButton(item: any, num: number) {
    if (item.type == DetailSidebarItems.DEVICES) {
      this.deviceDropdownOpened = !this.deviceDropdownOpened;
      return;
    } else {
      this.deviceDropdownOpened = false;
    }

    this.selectedItemType = item?.type;
    this.selectedButtonIndex = num;
    this.selectedButtonName = this.items[num].label;
    this.selectedRoute = this.items[num].route || undefined;
  
    if (this.selectedRoute == '' || this.selectedRoute == undefined) {
      this.toastr.info('Not implemented yet!');
    } else
      this.router.navigate([this.selectedRoute], { relativeTo: this.route });
  }

  deviceItemClicked() {
    this.deviceDropdownOpened = false;
    this.toastr.info('Not implemented yet!');
  }
}
